import { Link } from 'react-router-dom';
import { allArticles } from '@/mocks/articles';

export default function ArticleSection() {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs md:text-sm font-medium mb-4 whitespace-nowrap">
            Pandabuy Sheet Guides
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Pandabuy Spreadsheet Shopping Guides
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Expert-curated guides to help you master Pandabuy shopping — from beginner walkthroughs to advanced deal-finding strategies.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {allArticles.map((article, index) => (
            <Link
              key={article.slug}
              to={`/${article.slug}`}
              className="group relative rounded-2xl overflow-hidden aspect-[4/5] bg-background-100 cursor-pointer animate-fade-in-up"
              style={{ animationDelay: `${index * 0.04}s` }}
            >
              <img
                src={article.image}
                alt={article.title}
                title={article.title}
                className="absolute inset-0 w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              <div className="absolute top-3 left-3">
                <span className="inline-block px-2.5 py-1 rounded-full bg-white/20 backdrop-blur-sm text-white/90 text-xs font-medium whitespace-nowrap">
                  {article.category}
                </span>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                <h3 className="font-heading text-white text-sm md:text-base font-semibold mb-1 line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-white/70 text-xs mb-2 line-clamp-1">
                  {article.subtitle}
                </p>
                <span className="text-white/55 text-xs">{article.readTime}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}